import gql from 'graphql-tag';

export const contractBalancesQuery = gql`
  query ($advertiserId: String!, $advertiserNation: String!) {
    contractBalances(
      advertiserId: $advertiserId
      advertiserNation: $advertiserNation
    ) {
      contractType
    }
  }
`;
